import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M43.59 92.17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M79.58 13.69l3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path fill="#0597A3" d="M96.57 25.68a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M31.07 92.73H25.5v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M13.63 77.61c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#001A43"
      d="M71.66 61.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25H62V38.08h9.66c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25H59.75c-1.24 0-2.25 1.01-2.25 2.25v20.92h-9.66c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h9.66v20.92c0 1.24 1.01 2.25 2.25 2.25h11.91c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25H62V61.25z"
    />
    <path
      fill="#00D8D8"
      d="M79.15 66.71a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M79.15 43.33a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M79.15 89.67a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
    />
    <path
      fill="#0597A3"
      d="M44.34 45.65h-11.5a3.49 3.49 0 0 0-3.49 3.49v20.13a3.49 3.49 0 0 0 3.49 3.49h11.5a3.49 3.49 0 0 0 3.49-3.49V49.14a3.49 3.49 0 0 0-3.49-3.49"
    />
  </svg>
);
const SvgEnrichedIconOrganizeInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconOrganizeInverted);
export default Memo;
